import { useOrganization } from '@clerk/react';

import SwipooPro from '../screens/SwipooPro/index.tsx';
import Backoffice from './Backoffice';
import Spinner from '../components/Spinner';

export default function Main() {
  const { isLoaded, organization } = useOrganization();

  if (!isLoaded)
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-zinc-50">
        <Spinner color="text-blue-700" size={10} />
      </div>
    );

  return organization?.id === process.env.REACT_APP_SWIPOO_ORG_ID ? (
    <Backoffice />
  ) : (
    <SwipooPro />
  );
}
